(function () {
  const modal = document.getElementById("upsBidModal");
  if (!modal) return;

  // Build content container if missing
  let content = modal.querySelector(".ups-bid-content");
  if (!content) {
    content = document.createElement("div");
    content.className = "ups-bid-content";
    modal.querySelector(".ups-bid-panel")?.appendChild(content);
  }

  function openModal(productUrl) {
    // Mobile: go straight to product page (no embedding issues, fastest)
    if (window.matchMedia("(max-width: 768px)").matches) {
      window.location.href = productUrl;
      return;
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    content.innerHTML = `<div style="font-weight:900;padding:10px;">Loading auction…</div>`;

    // Fetch product HTML (same-origin) and extract auction slot
    fetch(productUrl + (productUrl.includes("?") ? "&" : "?") + "ups_modal=1", { credentials: "same-origin" })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const slot = doc.querySelector("#auction-today-slot");
        if (!slot) {
          content.innerHTML = `<div style="padding:10px;">Auction widget not found. <a href="${productUrl}">Open product page</a></div>`;
          return;
        }
        content.innerHTML = slot.innerHTML;
      })
      .catch(() => {
        content.innerHTML = `<div style="padding:10px;">Could not load auction. <a href="${productUrl}">Open product page</a></div>`;
      });
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (content) content.innerHTML = "";
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".ups-bid-btn");
    if (btn) {
      const url = btn.getAttribute("data-ups-bid-url");
      if (url) openModal(url);
      return;
    }

    if (e.target.closest("[data-ups-bid-close]")) {
      closeModal();
      return;
    }

    // Close if clicking any link while open (prevents “gray banner stuck”)
    if (modal.classList.contains("is-open")) {
      const a = e.target.closest("a[href]");
      if (a && !a.closest("#upsBidModal")) closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
  });

  window.addEventListener("popstate", closeModal);
  window.addEventListener("hashchange", closeModal);
  document.addEventListener("shopify:section:load", closeModal);
  document.addEventListener("page:load", closeModal);
  document.addEventListener("page:change", closeModal);
})();
